import styled from "styled-components";

const Box = styled.div`
  position: relative;

  ${props =>
    typeof props.width === "string"
      ? `
    flex: 0 0 ${props.width};
    width: ${props.width};
  `
      : false};

  ${props =>
    Array.isArray(props.width)
      ? ` 
    flex: 0 0 ${props.width[0]};
    width: ${props.width[0]};
    @media(min-width: 960px) {
      flex: 0 0 ${props.width[1]};
      width: ${props.width[1]};
    }
  `
      : false};
`;

export default Box;



// WEBPACK FOOTER //
// ./src/UI/Layout/Box.js